import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { RegionModel } from "../models/region/regionModel";
import { RegionFilterSettingsModel } from "../models/region/regionFilterSettingsModel";

class RegionService {
    authService = new AuthService();
    constructor() {
        axios.defaults.baseURL = `${Constants.apiUrl}/`;
        axios.defaults.headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    }

    getAllRegions(from: number, numberOfRows: number, settings: RegionFilterSettingsModel) {
        return axios({
            url: `regions/getAll/${from}/${numberOfRows}`,
            method: 'post', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(settings)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getAllActiveRegions() {
        return axios({
            url: `regions/getAllActive`,
            method: 'get', headers: {
                "Content-Type": "application/json; charset=utf-8"
            }
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getRegion(id: number) {
        return axios({
            url: `regions/getById/${id}`,
            method: 'get'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    addRegion(region: RegionModel) {
        return axios({
            url: `regions/create`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(region)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    editRegion(region: RegionModel) {
        return axios({
            url: `regions/update`,
            method: 'put',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(region)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deleteRegion(id: number) {
        return axios({
            url: `regions/delete/${id}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default RegionService;
